const resource = '/card'
export default ($axios, baseUrl) => ({
  all() {
    return $axios.get(`${baseUrl}${resource}`)
  },

  show(id) {
    return $axios.get(`${baseUrl}${resource}/${id}`)
  },

  create(payload) {
    return $axios.post(`${baseUrl}${resource}`, payload)
  },

  update(id, payload) {
    return $axios.post(`${baseUrl}${resource}/${id}`, payload)
  },

  delete(id) {
    return $axios.delete(`${baseUrl}${resource}/${id}`)
  },
})
